export const calculateResearchCost = (numQuestions, numPersonas, hasSubscription = false, isRegeneration = false) => {
  // For subscribed users who are regenerating responses
  if (hasSubscription && isRegeneration) {
    return 0; // Free regeneration for subscribers
  }
  
  // For subscribed users with regular research
  if (hasSubscription) {
    // Check if exceeds subscription limits
    const baseQuestions = 15;
    const basePersonas = 100;
    
    // Calculate excess
    const excessProduct = Math.max(0, (numQuestions * numPersonas) - (baseQuestions * basePersonas));
    
    // €1 per additional (question×persona)
    return excessProduct;
  }
  
  // For non-subscribed users (pay-as-you-go)
  const basePrice = 5;
  const baseQuestions = 10;
  const basePersonas = 20;
  
  // For regeneration requests
  if (isRegeneration) {
    return 1; // €1 per regeneration
  }
  
  // Regular pay-as-you-go research
  // Calculate excess over the base
  const excessProduct = Math.max(0, (numQuestions * numPersonas) - (baseQuestions * basePersonas));
  
  return basePrice + excessProduct;
};

export const FREE_RESEARCH_LIMITS = {
  MAX_QUESTIONS: 10,
  MAX_PERSONAS: 20,
  DAYS_BETWEEN_FREE: 7
};

export const SUBSCRIPTION_LIMITS = {
  MAX_QUESTIONS: 15,
  MAX_PERSONAS: 100,
  WEEKLY_RESEARCHES: 10
};

export const isEligibleForFreeResearch = (lastFreeResearch) => {
  if (!lastFreeResearch) return true;
  
  const lastDate = new Date(lastFreeResearch);
  const now = new Date();
  const diffDays = Math.floor((now - lastDate) / (1000 * 60 * 60 * 24));
  
  return diffDays >= FREE_RESEARCH_LIMITS.DAYS_BETWEEN_FREE;
};